import nextId from "react-id-generator"

export const links = [
    {
        id: nextId(),
        url: "#home",
        text: "home"
    },
    {
        id: nextId(),
        url: "#featured",
        text: "featured"
    },
    {
        id: nextId(),
        url: "#female",
        text: "female"
    },
    {
        id: nextId(),
        url: "#new",
        text: "new"
    },
    {
        id: nextId(),
        url: "#shop",
        text: "shop"
    },
]